import store from '@/store';
import CryptoJS from 'crypto-js';

export default function hasPermission(name = null) {
  const user = store.getters['app/currentUser'];
  const roles = user && user.permissions_list || [];
  return roles.indexOf(name) !== -1;
}

export function hasDashboardPermission(name = null) {
  const user = store.getters['app/currentUser'];
  // eslint-disable-next-line camelcase
  const roles = user && user.dashboard_permission_list || [];
  return roles.indexOf(name) !== -1;
}

export function hasPermissions(list = []) {
  const user = store.getters['app/currentUser'];
  const permissionsList = user && user.permissions_list || [];
  return list.some(permission => permissionsList.includes(permission));
}

export function hasCustomFieldPermission(name) {
  const user = store.getters['app/currentUser'];
  const permissions = (user && user.custom_field_permissions) || [];
  return permissions.indexOf(name) !== -1;
}

export function getDecrypt(data, appSecret) {
  const bytes = CryptoJS.AES.decrypt(data, appSecret);
  return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
}
